export const headTableCells = [
  {
    title: 'Practice Management Charge Description',
    label: 'Practice Management Charge Description',
    fieldName: 'charge_code_name_sort',
    display: true,
  },
  {
    title: 'Modified Date',
    label: 'Modified Date',
    fieldName: 'charge_code_updated_at_sort',
    display: true,
  },
  {
    title: '',
    label: '',
    align: 'text-center',
    display: true,
  }
];
